import { TNotSupportedErrorFactory } from '../types';

export const createNotSupportedError: TNotSupportedErrorFactory = () => new DOMException('', 'NotSupportedError');
